import {} from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import DetailHeaderWithText from 'components/foundation/DetailHeaderWithText/DetailHeaderWithText';
import HeaderDialog from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IEquipmentTypesDialogProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
}

const EquipmentTypesDialog = (props: IEquipmentTypesDialogProps) => {
  const { className, isOpen, onClose } = props;

  const classes = classNames('equipment-types-dialog', className);

  return (
    <HeaderDialog className={classes} title={t('Equipment Types')} divider={false} isOpen={isOpen} onClose={onClose}>
      <div className="mx-8 my-2">
        <DetailHeaderWithText
          title={t('Equipment')}
          value={t(
            'Large machines or vehicles that normally require an operator when in use. This is the only type with hour meter support.'
          )}
        />

        <DetailHeaderWithText title={t('Tools')} value={t('Medium to small items.')} />

        <DetailHeaderWithText
          title={t('Attachments')}
          value={t(
            'These items can only be tracked as add-ons. They are usually dependent on other tools or equipment.'
          )}
        />
      </div>
    </HeaderDialog>
  );
};

export default EquipmentTypesDialog;
